import React from 'react';

/** Autocorrect Undo. Hidden until the pointer is over the corrected value. */
const PathSlashUndo = ({ onUndo }) => (
  <button
    type="button"
    className="variables-panel__slash-undo"
    title="Restore the slashes you typed"
    aria-label="Undo slash correction"
    onMouseDown={(e) => {
      e.preventDefault();
      e.stopPropagation();
    }}
    onClick={(e) => {
      e.preventDefault();
      e.stopPropagation();
      onUndo?.();
    }}
  >
    Undo
  </button>
);

export default PathSlashUndo;
